import { connect } from 'react-redux';

import { toggleFiltersPanelAction } from 'checkout/store/actions/view';
import { getShowFiltersModal } from 'checkout/store/selectors/view';
import { getIsMobile } from 'src/store/view/selectors';

import { getIsHomePath } from 'src/routes/Checkout/store/selectors/router';

import {
  getSelectedFiltersCount,
  isInitialFlightsFetchingDoneSelector,
} from '../../../store/flights-filters';

import ShowFiltersButton from './ShowFiltersButton';

const mapStateToProps = (state) => ({
  filtersCount: getSelectedFiltersCount(state),
  isMobile: getIsMobile(state),
  isModalShown: getShowFiltersModal(state),
  areInitialFlightsFetchingDone: isInitialFlightsFetchingDoneSelector(state),
  isFlightsPage: getIsHomePath(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleFiltersPanel: () => dispatch(toggleFiltersPanelAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowFiltersButton);
